import React, { Component } from 'react'
import { Link } from "react-router-dom";
import { Row } from 'reactstrap';
import PropTypes from 'prop-types'
import SearchBox from './SearchBox'
import CategoryList from './CategoryList'
import Loading from './Loading'
import Source from '../../Source'
import { Helmet } from "react-helmet";
import { removeGrayBody } from './BodyBg'

const source = new Source();

export class Category extends Component {
    state = {
        items: [],
        showLoading: true,
        brief: "",
        name: "中国合同库",
        image: "",
        code: ""
    }

    loadCategory = () => {
        fetch('https://fatianshi.blob.core.chinacloudapi.cn/resource/templatecategory.json', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(Response => Response.json()).then(
            json => {
                console.log(json)
                this.setState({ items: json, showLoading: false });
                //console.log(this.state.items)
            }

        )
    }

    componentDidMount() {
        removeGrayBody();

        this.loadCategory();

        if (source.getParam() != undefined) {
            fetch('/api/user/GetPartnerInfo?source=' + source.getParam(), {
                method: 'GET',
            })
                .then(
                    Response => {
                        if (Response.ok) {
                            return Response.json();
                        }
                        throw new Error('no dealer info');
                    }
                )
                .then((json) => {
                    var sourceValue = { brief: json.Brief, name: json.Name, image: json.Image, code: json.Code, showLoading: false  };
                    console.log(sourceValue)
                    this.setState(sourceValue);
                    source.setSource(JSON.stringify(sourceValue));
                })
                .catch(error => console.error(error))
        }
        else
            if (source.getSource() != undefined) {
                const sourceValue = source.getSource();
                console.log(sourceValue)
                this.setState({ brief: sourceValue.brief, image: sourceValue.image, name: sourceValue.name, showLoading: false })
            }
    }

    render() {
        console.log(this.state.name)
        return (
            <div className="pt-5">
                <Row>
                    <div className="dealerInfo center">
                        <h1>{this.state.name}</h1>
                        <p>{this.state.brief}</p>
                    </div>
                </Row>
                <Row>
                    <SearchBox />
                </Row>
                <Row className="mt-5">
                    <CategoryList />
                </Row>
                <Helmet>
                    <title>{this.state.name}</title>
                </Helmet>
                <Loading isLoading={this.state.showLoading} />
            </div>
        )
    }
}

export default Category